module.exports = __webpack_public_path__ + "img/Sustainable1.518b4c13.jpg";